export default "__VITE_ASSET__bd06711d__"